module.exports = __webpack_public_path__ + "img/neo4j.903b6a86.png";